import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette } from '../../theme';
import { ExpertCardType } from './ExpertCard';

const useStyles = (type: ExpertCardType) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        background: type === 'dark' ? colorsPalette.blueDark : theme.palette.secondary.light,
        borderRadius: 10,
        height: 300,
        overflow: 'hidden',
        position: 'relative',
        [theme.breakpoints.up('md')]: {
          height: 348,
        },
      },
      container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        position: 'relative',
      },
      imgWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 198,
        overflow: 'hidden',
        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          left: 0,
          bottom: -3,
          width: '100%',
          height: 133,
          background:
            type === 'dark'
              ? 'linear-gradient(0deg, #1B1925 0%, rgba(27, 25, 37, 0.901961) 17.24%, rgba(27, 25, 37, 0) 100%)'
              : 'linear-gradient(0deg, rgba(35, 32, 46, 1) 0%, rgba(36, 34, 47, 0.9) 17%, rgba(45, 50, 56, 0) 100%) 0% 0% no-repeat',
          '-webkit-background-origin': 'padding-box',
          '-o-background-origin': 'padding-box',
          '-moz-background-origin': 'padding-box',
          zIndex: 0,
        },

        [theme.breakpoints.up('md')]: {
          height: 274,
        },
      },
      imgLazyWrapper: {
        width: '100%',
        height: '100%',
        position: 'relative',
      },
      img: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      textWrapper: {
        padding: '0 24px 21px 24px',
        zIndex: 2,
      },
      link: {
        color: colorsPalette.white,
      },
      title: {
        fontSize: 18,
        lineHeight: '22px',
        fontWeight: 'bold',
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        marginBottom: 9,
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
          lineHeight: '25px',
        },
      },
      jobTitle: {
        fontSize: 12,
        lineHeight: '15px',
        color: colorsPalette.gray,
        [theme.breakpoints.up('md')]: {
          fontSize: 14,
          lineHeight: '18px',
        },
      },
      accompanyingText: {
        fontSize: 12,
        lineHeight: '15px',
        color: colorsPalette.violet,
        [theme.breakpoints.up('md')]: {
          fontSize: 14,
          lineHeight: '18px',
        },
      },
    }),
  );
export default useStyles;
